/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';

import { FormSection, Separator } from '@fitinsur/components'

import { GeneralSection } from '../../general/index';
import { ObligorPercSection } from '../index';
import { ObligorContractSection } from '../../obligorContract/index';

import * as Styled from './styles';

function RenderSection({
  disableAll,
  formikProps,
  formikRef,
  isBound,
  obligorGroup,
  setObligorGroup,
  idProduct,
  isMAS,
  isNewYork,
  idOperation,
  idOperationParent,
  globalQuestionnaire,
  setGlobalQuestionnaire,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  mc,
}) {

  return (
    <div style={{ width: "100%", display: "flex" }}>
      <div style={{ width: "50%", display: "flex", flexDirection: "column" }}>
        {obligorGroup?.map((questions, index) => {
          if (idProduct) {
            return (
              <FormSection
                key={index}
                sectionIndex={index}
                sectionName="OBLIGOR_PERC"
                formikRef={formikRef}
                disableAll={disableAll}
                values={formikProps.values}
                errors={formikProps.errors}
                setFieldValue={formikProps.setFieldValue}
                setFieldError={formikProps.setFieldError}
                questionnaire={questions}
                idOperation={idOperation}
                idOperationParent={idOperationParent}
                idProduct={idProduct}
                extraButtons={() => {
                  if (!isMAS && !isNewYork) return null;

                  return GeneralSection.components.RenderSectionAddAndRemoveRowButtons({
                    partySectionName: "OBLIGOR_PERC",
                    sectionState: obligorGroup,
                    setSectionState: setObligorGroup,
                    index,
                    questions,
                    questionnaireAnswersToDelete,
                    setQuestionnaireAnswersToDelete,
                    onRemove: (newArray, groupQuestionnaireAnswersToDelete) => {
                      ObligorPercSection.events.handleSelectedObligorCodings({
                        updatedObligorGroup: newArray,
                      })

                      ObligorPercSection.events.handleObligorCodingTotal({
                        obligorGroup: newArray,
                        setFieldValue: formikProps.setFieldValue,
                        setFieldError: formikProps.setFieldError,
                        mc,
                      });
                    }
                  });
                }}
                onQuestionChange={(
                  question,
                  value,
                  questionnaireUpdated,
                  setQuestionnaireUpdated
                ) => {
                  ObligorPercSection.events.handleQuestionChange({
                    question,
                    value,
                    questionnaireUpdated,
                    updatedObligorGroup: obligorGroup.map((v, i) => i === index ? questionnaireUpdated : v),
                    setObligorGroup,
                  });
                }}
                onBlur={(
                  question,
                  value,
                  questionnaireUpdated,
                  setFilteredQuestionnaire,
                  setFieldValue
                ) => {
                  ObligorPercSection.events.handleQuestionBlur({
                    question,
                    setObligorGroup,
                    updatedObligorGroup: obligorGroup.map((v, i) => i === index ? questionnaireUpdated : v),
                    setFieldValue,
                    setFieldError: formikProps.setFieldError,
                    mc,
                  });
                }}
              />
            );
          }
        })}

        {formikProps.values.obligorCodingTotal != null && (
          <Styled.RenderSectionTotalContainer>
            <Separator style={{ marginLeft: 0 }} width="calc(80% - 20px)" />

            <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
              <GeneralSection.components.Styled.Text style={{ width: "50%" }}>
                TOTAL
              </GeneralSection.components.Styled.Text>

              <GeneralSection.components.Styled.Text style={{ width: "50%", whiteSpace: "nowrap" }}>
                {parseFloat(formikProps.values.obligorCodingTotal).toFixed(5) || "0.00000"}%
              </GeneralSection.components.Styled.Text>
            </div>
          </Styled.RenderSectionTotalContainer>
        )}
      </div>

      <div style={{ width: "50%", display: "flex", flexDirection: "column" }}>
        <ObligorContractSection.components.RenderSection
          formikRef={formikRef}
          disableAll={disableAll}
          formikProps={formikProps}
          isBound={isBound}
          questionnaire={globalQuestionnaire}
          idOperation={idOperation}
          idOperationParent={idOperationParent}
          idProduct={idProduct}
        />
      </div>
    </div>
  )
}

const components = {
  RenderSection
}

export { components }